var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCartIncIcon = function SvgCartIncIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12855"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32a8 8 0 0 1 8 8v26a8 8 0 0 1-8 8H0z",
    "data-name": "Rectangle 240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 22.037v-2.058h14v2.058ZM18.895 14h2.227v14h-2.227Z",
    "data-name": "Path 2485"
  }))));
};
export default SvgCartIncIcon;